import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  container: {
    display: "flex",
    gap: 16,
    flexDirection: "column",
    // marginTop: 64,
    alignItems: "center",
    marginBottom: 32,
    padding: "0 72px 0 72px",
    maxWidth: 600,
    margin: "auto",
    [theme.breakpoints.down("xl")]: {
      padding: "0 32px",
    },
  },

  body: {
    marginTop: -64,
    paddingBottom: 32,
    minHeight: 640,
    background: "url(/assets/imgs/crime/crime_bg.png) no-repeat",
    backgroundSize: "100% auto",

    [theme.breakpoints.down("sm")]: {
      backgroundPosition: "left top",
      backgroundSize: "auto auto",
    },
  },

  header: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    marginTop: 120,
    fontFamily: "Philosopher",
    fontWeight: "900",
    gap: 16,

    "& img": {
      width: 64,
      height: 64,
    },
  },

  content: {
    display: "flex",
    gap: 60,
    marginTop: 4,

    "& img": {
      borderRadius: 12,
      width: 300,
      height: 300,
      objectFit: "contain",
    },

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },

  contentDetail: {
    display: "flex",
    flexDirection: "column",
    gap: 32,
    marginTop: 24,
  },

  bribeOutButton: {
    minWidth: 100,
    borderRadius: 16,
    background: "rgb(255, 255, 255, 0.2)",
    textDecoration: "none",
    fontFamily: "Philosopher",
    fontWeight: 900,
    fontSize: 14,
    display: "flex",
    gap: 8,
    color: "white",
    padding: "8px 24px",

    "& p": {
      fontSize: 14,
      textTransform: "none",
    },

    "& img": {
      width: "24px!important",
      height: "24px!important",
    },

    "&:disabled": {
      color: "rgba(255, 255, 255, 0.5)",
    },
  },
  contentDetailItem: {
    display: "flex",
    flexDirection: "column",
    gap: 8,

    [theme.breakpoints.down("sm")]: {
      "& p": {
        textAlign: "center",
      },
    },
  },
}));

export default styles;
